import axios from 'axios'
import { Toast } from 'vant'

import { getPlatform, PLATFROM_NAME } from './zjs'

const platformName = getPlatform().platform
const isDev = location.hostname === 'localhost' || /^[\d.]+$/.test(location.hostname)
const prd =
  !isDev && platformName !== PLATFROM_NAME.LIAONING && platformName !== PLATFROM_NAME.RENRENTONG

// const VUE_APP_serve = process ? process.env.VUE_APP_serve : false
// const mopaUrl = VUE_APP_serve === 'weixin' ? 'https://prd.zuul.leziedu.com' : 'https://dev.zuul.leziedu.com'

const mopaUrl = prd ? 'https://prd.zuul.leziedu.com' : 'https://dev.zuul.leziedu.com'

// 处理mopa的url
function getMopaUrl(url) {
  if (url.includes('/mopa')) {
    url = url.replace('/mopa', '')
    return mopaUrl + url
  }
  return url
}
const request = axios.create({
  timeout: 20000
})
request.interceptors.request.use(
  function(config) {
    // 重写mopa的url
    config.url = getMopaUrl(config.url)
    return config
  },
  function(error) {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 处理服务器502
    if (error.response.status === 502) {
      window.location.href = 'https://prd.oss.leziedu.com/utils/html/502.html'
    }
    // 处理广告json为空的报错情况
    if (error.request.responseURL.includes('/adv') && error.response.status === 403) {
      return Promise.reject(error)
    }
    // 异常处理，调用统一异常函数
    if (!error.config.notShowToast) {
      Toast('网络异常，请稍后再试')
    }
    setTimeout(() => {
      Toast.clear()
    }, 2000)
    return Promise.reject(error)
  }
)
export default request
